import { useFetch } from "../../../../hooks/api";

// Module-level so the list keeps its identity until the response changes.
const selectTemplates = (res) => res.data.results;
const noTemplates = [];

export const useAudienceTemplates = () => {
  const { data: templates, isLoading } = useFetch(
    ["audienceTemplates"],
    "/amc/audiencetemplateform",
    {},
    {
      select: selectTemplates,
    },
  );

  // One shared empty list until they load, so memos built on it don't rerun on every render.
  return { templates: templates ?? noTemplates, isLoading };
};
